import { calculateExperience } from '../experienceCalculator.js';

let periodCount = 0;

function addPeriod() {
    periodCount++;
    const container = document.getElementById('periodsContainer');
    const div = document.createElement('div');
    div.className = 'period-group';
    div.id = `period-${periodCount}`;
    div.innerHTML = `
        <div class="period-row">
            <div>
                <label>Start Date</label>
                <input type="date" id="start-${periodCount}">
            </div>
            <div>
                <label>End Date</label>
                <input type="date" id="end-${periodCount}" disabled>
            </div>
            <div style="display: flex; align-items: center; gap: 0.5rem; margin-top: 1.5rem;">
                <input type="checkbox" class="present-checkbox" id="present-${periodCount}" data-id="${periodCount}" checked>
                <label for="present-${periodCount}" style="margin: 0;">Current Job</label>
            </div>
            <button class="btn-danger remove-btn" data-id="${periodCount}" style="margin-top: 1.5rem;">Remove</button>
        </div>
    `;
    container.appendChild(div);
}

function calculate() {
    const periods = [];
    for (let i = 1; i <= periodCount; i++) {
        const el = document.getElementById(`period-${i}`);
        if (!el) continue;
        
        const startDate = document.getElementById(`start-${i}`).value;
        const isPresent = document.getElementById(`present-${i}`).checked;
        const endDate = document.getElementById(`end-${i}`).value;

        if (startDate) periods.push({ startDate, endDate, isPresent });
    }

    const result = calculateExperience(periods);
    const formatDuration = (d) => `${d.years}y ${d.months}m ${d.days}d`;
    const formatDate = (date) => date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });

    let html = `
        <div class="result-card">
            <p style="margin: 0; font-size: 0.875rem; text-transform: uppercase; font-weight: 600; color: #4f46e5; letter-spacing: 0.05em;">Total Accumulated Experience</p>
            <h2 class="result-total">${formatDuration(result.total)}</h2>
            <p class="result-sub">Based on ${result.total.totalDays} total days of employment.</p>
            <p style="font-size: 0.75rem; color: #6b7280; margin-top: 0.5rem;">
                Decimal: ${result.total.decimalYears.toFixed(2)} years. Overlapping periods are merged.
            </p>
        </div>
    `;

    if (result.mergedIntervals.length > 0) {
        html += '<h3>Valid Experience Periods (Overlaps Merged)</h3><div class="interval-list">';
        result.mergedIntervals.forEach(interval => {
            html += `<div class="interval-item">
                <span>${formatDate(interval.start)} → ${interval.isPresent ? 'Present' : formatDate(interval.end)}</span>
                <strong>${formatDuration(interval.duration)}</strong>
            </div>`;
        });
        html += '</div>';
    }

    if (result.gaps.length > 0) {
        html += '<h3>Gaps Between Employment</h3><div class="gap-list">';
        result.gaps.forEach(gap => {
            html += `<div class="gap-item">
                <span>${formatDate(gap.start)} → ${formatDate(gap.end)}</span>
                <strong>${formatDuration(gap.duration)}</strong>
            </div>`;
        });
        html += '</div>';
    }

    document.getElementById('results').innerHTML = html;
}

// Event Delegation
document.getElementById('periodsContainer').addEventListener('click', (e) => {
    if (e.target.classList.contains('remove-btn')) {
        const id = e.target.getAttribute('data-id');
        document.getElementById(`period-${id}`).remove();
    }
});

document.getElementById('periodsContainer').addEventListener('change', (e) => {
    if (e.target.classList.contains('present-checkbox')) {
        const id = e.target.getAttribute('data-id');
        const isPresent = e.target.checked;
        const endInput = document.getElementById(`end-${id}`);
        endInput.disabled = isPresent;
        if (isPresent) endInput.value = '';
    }
});

document.getElementById('addPeriodBtn').addEventListener('click', addPeriod);
document.getElementById('calculateBtn').addEventListener('click', calculate);

// Initialize with one period
addPeriod();
